import $ from 'jquery/dist/jquery.min'

$(document).ready(function() {
  const $button = $('.js-property-filter-button')
  const $dropdownContent = $('.property-filter-content')
  const $body =  $("html, body")

  if ($button) {
    $button.on('click', () => {
      $dropdownContent.toggleClass('show');
      $("html, body").animate({ scrollTop: 0 }, "slow");

      if ($dropdownContent.hasClass('show')) {
        $button.attr('aria-expanded', 'true')
        $dropdownContent.attr('aria-hidden', 'false')
        $body.css('height', '100vh')
        $body.css('overflow', 'hidden')
      } else {
        $button.attr('aria-expanded', 'false')
        $dropdownContent.attr('aria-hidden', 'true')
        $body.css('height', 'auto')
        $body.css('overflow', 'auto')
      }
    })
  }

  const $dropdownSearchInput = $('.js-property-filter-search-input')
  if ($dropdownSearchInput) {
    $dropdownSearchInput.on('keyup', () => {
      const keyword = $dropdownSearchInput.val().toUpperCase()
      const $options = $('.js-property-filter-options').find('a')
            
      $options.each(function( index ) {
        const value = $(this).text()
        if (value.toUpperCase().indexOf(keyword) > -1)  {
          $(this).show()
        } else {
          $(this).hide()
        }
      });
    })
  }
});



// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/PropertyFilter.jsx